import { apolloClient } from "../../vue-apollo";
import {
    GET_PAGINAS_NOTIFICACIONES,
    GET_NOTIFICACIONES_PAGINADAS,
    GET_MODULOS_INTRANET
} from "../../graphql/queries";
import {
    DELETE_NOTIFICACIONES,
    VISTO_NOTIFICACIONES,
} from "../../graphql/mutations";

export default {
    namespaced: true,
    state: {
        notificaciones: [],
        paginas_notificaciones: [],
        listaMenuValidacion: []
    },
    getters: {
    },
    mutations: {
        SET_PAGINAS_NOTIFICACIONES(state, paginas)
        {
            state.paginas_notificaciones = paginas;
        }, 
        SET_NOTIFICACIONES(state, notificaciones){
            let data = [];
            //console.log("", notificaciones);
            notificaciones.forEach(element=>{
                let menu = state.listaMenuValidacion.find(objeto => objeto.moduloGeneral.id_modulo === element.id_modulo_fk);
                //console.log("menu: ", menu);
                data.push({
                    id: element.id_notificacion,
                    nombre_modulo: element.titulo_notificacion,
                    texto: element.texto_notificacion,
                    imagen: menu!=undefined?menu.imagen_url:"",//"/img/layout/icono-noticia@2x.png",
                    url: menu!=undefined? menu.ruta: "",//"/noticias",
                    vista: element.confirm_seen.id_usuario_fk==null?false:true,
                });
            });
            state.notificaciones = data;
        },
        DELETE_NOTIFICACIONES(state, notificaciones){
            //console.log("resultado de delete: ", notificaciones);
            let notificacion_index = -1;
            if (notificaciones.length>0 && notificaciones.length<=1){
                //console.log("solo una notificación", notificaciones);
                notificacion_index = state.notificaciones.findIndex(notificacion => notificacion.id == notificaciones[0].id_notificaciones_fk);
                if (notificacion_index != -1) {
                    //console.log('Notificación Encontrada', state.notificaciones[notificacion_index], "se debe agregar el cambio en el state");
                    state.notificaciones.splice(notificacion_index, 1);
                }
            }
            else{
                //console.log("se elimino todo: ", notificaciones)
                state.notificaciones.splice(0, notificaciones.length);
                //state.notificaciones = [];
            }
        
            //console.log("notificacion_index: ", notificacion_index)
        },
        CHANGE_ESTADO_VISTA_NOTIFICACIONES(state, notificaciones){
            let notificacion_index = state.notificaciones.findIndex(notificacion => notificacion.id == notificaciones[0].id_notificaciones_fk);
            // console.log("notificacion_index: ", notificacion_index);
            if (notificacion_index != -1) {
                state.notificaciones[notificacion_index].vista = true;
                //state.notificaciones[notificacion_index]
            }
        },
        // Menu para validar y crear nuevo objeto de notificaciones
        SET_MENU_FOR_VALIDACION(state, menu) {
            menu.forEach(function (data) {
                let ruta = "/";
                let nombre = data.moduloGeneral.nombre_modulo
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
                ruta += nombre.toLowerCase();
                data.ruta = ruta;
            });
            state.listaMenuValidacion = menu
            //menu.filter(module => module.moduloGeneral.nombre_modulo !== "Beneficios");

            
        },

    },
    actions: {
    
        async getPaginasNotificaciones({ commit }, data_){
            let response = null;
            let params = {
                query: GET_PAGINAS_NOTIFICACIONES,
                variables: data_,
                fetchPolicy: 'network-only'
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getPaginasNotificaciones: ", res.data.paginadorNotificacionesApp);
                if (!res.loading) response = res.data.paginadorNotificacionesApp;
            });
            }
            catch(e){
            console.log("Falla error, getPaginasNotificaciones ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        commit("SET_PAGINAS_NOTIFICACIONES", response);
                        resolve(false);
                    }
                    else {
                        commit("SET_PAGINAS_NOTIFICACIONES", response);
                        resolve(response);
                    }
                }
                else {
                    resolve(false);
                }
            });
        },
        async getMenuForValidacion({commit}, data_){
            let response = null;
            let params = {
                query: GET_MODULOS_INTRANET,
                variables: data_
            };
            try {
                await apolloClient.query(params).then((res) => {
                //console.log("respuest de server getMenuForValidacion: ", res.data.modulosIntranet);
                if (!res.loading) response = res.data.modulosIntranet;
                });
            } catch (e) {
                console.log("Falla error, getMenuForValidacion ", e);
            }
            commit("SET_MENU_FOR_VALIDACION", response);
        },
        /** Metodo  getNotificaciones nueva funcion que une todo el paginador con el resultado de los elementos en una sola función*/
        async getNotificaciones({ dispatch, commit }, payload)
        {
            let response = null;
            let paramsMenuValidacion = {
                id_empresa: payload.data2_.id_empresa,
                id_usuario: payload.data2_.id_usuario,
                id_privilegio: payload.id_privilegio
            }
            //console.log("paramsMenuValidacion: ", paramsMenuValidacion);
            await dispatch("getMenuForValidacion", paramsMenuValidacion);
            const paginateNotificacion = await dispatch("getPaginasNotificaciones", payload.data2_);
            let pagina = payload.pagina;
            let ids_notificacion = [];
            if (paginateNotificacion){
                paginateNotificacion.forEach((data)=>{
                    if(data.pagina == pagina){
                        ids_notificacion = data.notificaciones;
                    }
                }); 
            }
            //console.log("dato de paginacion: ", paginatedReconocimiento);
            let data_ = {
                id_empresa: payload.data2_.id_empresa,
                id_usuario: payload.data2_.id_usuario,
                id_notificacion: ids_notificacion
            }
            let params = {
                query: GET_NOTIFICACIONES_PAGINADAS,
                variables: data_,
                fetchPolicy: 'network-only'
            }
            try {
            await apolloClient.query(params).then(res => {
                //console.log("respuest de server getNotificaciones: ", res.data.listarNotificaciones);
                if (!res.loading) response = res.data.listarNotificaciones;
            });
            }
            catch(e){
            console.log("Falla error, getNotificaciones ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    if (response.length==0){
                        commit("SET_NOTIFICACIONES", response);
                        resolve(false);
                    }
                    else {
                        commit("SET_NOTIFICACIONES", response);
                        resolve(response);
                        
                    }
                }
                else {
                    resolve(false);
                }
            });
        },

        // Elimina un notificación o un grupo de notificaciones
        async deleteNotificaciones({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: DELETE_NOTIFICACIONES,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('DELETE_NOTIFICACIONES', res.data.borrarNotificacionLista);
                    if (!res.loading) data = res.data.borrarNotificacionLista;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo deleteNotificaciones: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    commit("DELETE_NOTIFICACIONES", response);
                    resolve(response);
                }
                else {
                resolve(false);
                }
        
            });
        },
        // Ver Notificaciones metodo que cambia el estado de una notificación de no vista a vista
        async verNotificacion({commit}, data_){
            let response = null;
            let data = [];
            let params = {
                mutation: VISTO_NOTIFICACIONES,
                variables: data_
            }
            try{
                await apolloClient.mutate(params).then(res => {
                    //console.log('CHANGE_ESTADO_VISTA_NOTIFICACIONES', res.data.insertarVistoNotificacion);
                    if (!res.loading) data = res.data.insertarVistoNotificacion;
                    response = data;
                });
            }
            catch(e){
                console.log("Falla metodo verNotificacion: ", e);
            }
            return new Promise((resolve)=>{
                if(response!=null){
                    commit("CHANGE_ESTADO_VISTA_NOTIFICACIONES", response);
                    resolve(response);
                }
                else {
                    resolve(false);
                }
        
            });
        },
    }
};